export const listTicketsMock = {
  total: 2,
  tickets: [
    {
      id: "500bL00000EOxjlQAD",
      number: "00193409",
      title: "Teste de Salesforce",
      order_number: null,
      description: "olá teste",
      product: "tiny",
      created_at: "2025-06-18T19:42:04.000+0000",
      updated_at: "2025-06-18T19:58:00.000+0000",
      status: "pendente",
    },
    {
      id: "500bL00000EOxjlQAD",
      number: "00193409",
      title: "Envio atrasado",
      order_number: null,
      description: "olá teste",
      product: "envios",
      created_at: "2025-06-18T19:42:04.000+0000",
      updated_at: "2025-06-18T19:58:00.000+0000",
      status: "novo",
    },
    {
      id: "500bL00000EOxjlQAD",
      number: "00193409",
      title: "Edição de anúncio",
      order_number: null,
      description: "olá teste",
      product: "store",
      created_at: "2025-06-18T19:42:04.000+0000",
      updated_at: "2025-06-18T19:58:00.000+0000",
      status: "fechado",
    },
    {
      id: "500bL00000EOxjlQAD",
      number: "00193409",
      title: "Pix errado",
      order_number: null,
      description: "olá teste",
      product: "conta_digital",
      created_at: "2025-06-18T19:42:04.000+0000",
      updated_at: "2025-06-18T19:58:00.000+0000",
      status: "aberto",
    },
    {
      id: "500Hr00001oFymUIAS",
      number: "00003720",
      title: "(41) 99615-0347 | OLIST SERVICOS DIGITAIS LTDA",
      order_number: null,
      description: null,
      product: "Olist",
      created_at: "2024-09-05T16:21:06.000+0000",
      updated_at: "2024-09-05T19:47:32.000+0000",
      status: "fechado",
    },
  ],
};
